import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ltx/phase-ii/anthropometrics";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	anthropometrics: {
		id: "form.anthropometrics",
		defaultMessage: "Antropometria"
	},
	weight: {
		id: "form.anthropometrics.weight",
		defaultMessage: "Testsúly"
	},
	height: {
		id: "form.anthropometrics.height",
		defaultMessage: "Magasság"
	},
	chestCircumference: {
		id: "form.anthropometrics.chestCircumference",
		defaultMessage: "Mellkaskörfogat"
	},
	abdominalCircumference: {
		id: "form.anthropometrics.abdominalCircumference",
		defaultMessage: "Haskörfogat"
	},
	bmi: {
		id: "form.anthropometrics.bmi",
		defaultMessage: "BMI"
	},
	bsa: {
		id: "form.anthropometrics.bsa",
		defaultMessage: "BSA"
	}
});

const fields: { [key: string]: FieldData } = {
	weight: {
		type: "field",
		path: ["weight"],
		label: messages.weight,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	height: {
		type: "field",
		path: ["height"],
		label: messages.height,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	chestCircumference: {
		type: "field",
		path: ["chestCircumference"],
		label: messages.chestCircumference,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	abdominalCircumference: {
		type: "field",
		path: ["abdominalCircumference"],
		label: messages.abdominalCircumference,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	bmi: {
		type: "field",
		path: ["bmi"],
		label: messages.bmi,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number", disabled: true } }
	},
	bsa: {
		type: "field",
		path: ["bsa", "dubois"],
		label: messages.bsa,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number", disabled: true } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{ width: 6, field: fields.weight },
				{ width: 6, field: fields.height }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.chestCircumference },
				{ width: 6, field: fields.abdominalCircumference }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.bmi },
				{ width: 6, field: fields.bsa }
			]
		}
	]
};

export const node: LeafNode = {
	id: "anthropometrics",
	value: {
		title: messages.anthropometrics,
		validator,
		fieldset,
		isImportant: true,
		applyCurrentDate: true
	}
};
